export default window._cmsContent['whd/check-status']